import { Tag } from "bbcode-to-react";
import * as React from "react";
class LineTag extends Tag {
    toHTML() {
        return ["<hr />", this.getContent()];
    }
    toReact() {
        return (React.createElement("div", null,
            React.createElement("hr", null),
            this.getComponents()));
    }
}
export default LineTag;
